<!--商品详情-->
<template>
<div>
  <mall-header ></mall-header>
  <mall-bread>
  <span style="color:#999">商品详情</span>
  </mall-bread>
  <div class="details-css" v-loading.fullscreen.lock="fullscreenLoading">
    <div style="float: left;">
      <img class="details-img" :src="detailobj.imgUrl"/>
    </div>
    <!--产品信息-->
    <div style="margin-left: 440px;padding-bottom: 40px;">
    <div>
      <div  class="details-info-css">{{detailobj.name}}</div>
      <div class="details-info-title-css" >{{detailobj.description}}</div>
    </div>

    <div class="sku-custom-title">
      <h6>
        <span></span>
        <div class="price" >
          <em>¥</em><i> {{detailobj.unitPrice}}</i></div>
      </h6>
    </div>
    <div class="details-info-num" >
      <span  class="select-num-css" >选择数量</span>
      <el-input-number v-model="num" size="large"  class="elInputNumber " style="    margin-left: 10px;border-radius: 0px;height: 36px; "  :min="1" :v-bind="detailobj.unit" ></el-input-number>
      <span  class="details-info-fen"  >{{detailobj.unit}}</span>
    </div>
   <div class="buy">
      <y-button text="立即购买" @btnClick="shopPay()"
                class="details-button-go" >
      </y-button>
      <img src="../../static/images/buttonShopCart.png" style="position: absolute;
    margin-left: 35px;
    margin-top: 12px;" />
      <y-button text="     加入购物车"
                @btnClick="addCart()"
                 class="details-button-join"
               ></y-button>
    </div>
    </div>
  </div>
  <div class="detail-server-div" >
      <span class="detail-server-font">服务详情</span>
      <div  style="margin: 90px 30px 30px 30px;    text-align: center;" v-html="detailobj.detail">
      </div>
      <el-backtop   style="right: initial;bottom: 40px;">
          <div class="el-backtop-div">
            <img src="../../static/images/backtop.png" style="margin-top: 15px;" />
          </div>
      </el-backtop>
  </div>
  <!-- <el-backtop  :bottom="100" style="right: initial" >
            <div
              style="
                height: 100%;
                width: 100%;
                box-shadow: 0 0 6px rgba(0,0,0, .12);
                text-align: center;
                line-height: 40px;
                color: #1989fa; ">
              <img src="../../static/images/backtop.png" style="      margin-top: 15px;width: 20px;height: 20px;"/>
            </div>
          </el-backtop> -->
  <div style="left: 0px;bottom: 0px;width: 100%;z-index:1;text-align: center; padding: 20px 0;    color: #999999;font-size: 14px;">
      Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved
    </div>

</div>
</template>
<script>
  import http from '../api/public'
  import YButton from '../components/YButton'
  import mallHeader from '../components/header.vue'
  import mallFooter from '../components/footer.vue'
  import mallBread from '../components/navbread.vue'
  // import { getStore } from '/utils/storage'
  import axios from 'axios'
  export default {
    data () {
      return {
        productMsg: {},
        small: [],
        detailobj:{},
        goodId:"",
        big: 1,
        product: {},
        productNum: 1,
        userId: '',
        mdShow:false,
        showText:'',
        ifCart:false,
        productId:'',
        fullscreenLoading:true,
        num: 1
      }
    },
    computed: {
    },
    mounted() {
     let afterUrl =  window.location.hash.substring(1);
        if(afterUrl){
            let str = afterUrl.indexOf('=')+1
            this.goodId = afterUrl.substring(str).toUpperCase();
        }else{
             this.goodId =  this.$route.query.id;
        }
      this.getdata(this.goodId);
    },
    methods: {
       getdata(goodId){
        axios.get('/mallApi/mall/index/queryById?id='+goodId).then((res) => {
          res = res.data;
          this.fullscreenLoading = false;
          this.detailobj = res.result
          this.detailobj.imgUrl = "/mallApi"+this.detailobj.imgUrl
          this.detailobj.unitPrice = http.changeUnitPrice(this.detailobj.unitPrice);
        });
      },
      editNum (num) {
        this.productNum = num
      },
      addCart() {
        var obj = {
            "quantity": this.num ,
            "serviceItemId": this.detailobj.id,
          }
            axios.post('/mallApi/mall/shopCart/add', obj,{headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
              res = res.data;
              console.log(res);
              if(res.success){
                this.$router.push({path: '/cart'});
                //  this.$message({
                //     showClose: true,
                //     message: '操作成功！',
                //     type: 'success'
                //   });
                // this.$router.go(0);
              }else {
               if(res.code == 401 ||  res.code == 400) {
                 this.$router.push({path: '/login?path='+this.$route.fullPath});
                }else{
                   this.$message({
                      showClose: true,
                      message: '操作失败！',
                      type: 'error'
                    });
                }
              }
            });
        },
      shopPay () {
        console.log(this.detailobj);
        var obj = {
            "quantity": this.num ,
            "serviceItemId": this.detailobj.id,
          }
            axios.defaults.headers ={
              "content-type": "application/json",
              "token": localStorage.getItem("Authorization")
            }
            axios.post('/mallApi/mall/order/createByShopCart', obj).then((res) => {
              res = res.data;
              if(res.success){
                 let tempData = res.result;
                 this.$router.push({path: '/orderconfirm', query: {"orderId":tempData.id}})
              }else {
                if(res.code == 401 ||  res.code == 403 || res.code == 400) {
                    console.log('请登录');
                    http.setLocalStorge();
                    this.$router.push({path: '/login?path='+this.$route.fullPath});
                }else{
                  this.$message({
                      showClose: true,
                      message: '操作失败！',
                      type: 'error'
                    });
                }
              }
            });
      }
    },
    components: {
      YButton,
      mallHeader,
      mallFooter,
      mallBread,
      http
    },
    //created () {
      //let id = this.$route.query.productId
      //this._productDet(id)
      //this.userId = getStore('userId')
    //}
  }
</script>
<style lang="scss" >
  @import '../assets/style/mixin.scss';

 .detail-server-div div.el-backtop {
    margin-left: 1220px ;
    bottom: 50px ;
    width: 50px ;
    height: 50px ;
    opacity: 0.1;
    border-radius: 25px ;
    background: rgb(0, 0, 0) ;
}
.detail-server-div .el-backtop:hover {
  opacity: 0.2 !important;
}
.el-backtop-divs{
   height: 100%;
  width: 100%;
  box-shadow: 0 0 6px rgba(0,0,0, .12);
  text-align: center;
  line-height: 40px;
  color: #1989fa;
}
div.elInputNumber.el-input-number.el-input-number--large span.el-input-number__decrease.is-disabled{
     color: #C0C4CC;
    background: #F6F6F6 !important;
    cursor: not-allowed;
     width: 36px!important;
    height: 36px!important;
    line-height: 36px !important;
    border-radius:  0px;
}
div.elInputNumber.el-input-number.el-input-number--large span.el-input-number__decrease{
     width: 36px!important;
    height: 36px!important;
    background: #FFFFFF;
    line-height: 36px !important;
    border-radius:  0px;
    color: #333333;
}
div.elInputNumber.el-input-number.el-input-number--large span.el-input-number__increase{
     width: 36px!important;
    height: 36px!important;
    background: #FFFFFF;
    line-height: 36px !important;
    border-radius:  0px;
    color: #333333;
}
 div.el-input-number--large input.el-input__inner{
    line-height: 38px !important;
    height: 38px!important;
    border-radius:0px;
}
 .elInputNumber {
      position: relative;
      display: inline-block;
      width: 142px !important;
      line-height: 38px !important;
      font-size: 16px!important;
        border-radius: 0px;
   }

 .details-info-fen{
       width: 15px;
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 20px;    margin-left: 10px;
      }
    // 右边
    .banner {
      width: 580px;
      margin-left: 10px;
      h4 {
        font-size: 16px;
        font-weight:700;
        line-height: 1.25;
        color: #000;
        margin-bottom: 13px;
      }
      h6 {
        font-size: 14px;
        line-height: 1.5;
        color: #bdbdbd;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .sku-custom-title {
        overflow: hidden;
        padding: 8px 8px 18px 10px;
        position: relative;
      }
      .params-name {
        width: 63px;
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 20px;

      }

      .num {
        padding: 29px 0 8px 10px;
        border-top: 1px solid #ebebeb;
        display: flex;
        align-items: center;
      }
      .buy {
        position: relative;
        border-top: 1px solid #ebebeb;
        padding: 30px 0 0 10px;
            float: left;
        margin-left: 440px;
        margin-top: -118px;
      }
    }

.select-num-css{font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #666666;line-height: 20px;}
  .price {
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FF620D;
  }
  .details-css{
	    width: 1200px;
    min-width: 1200px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    margin: 0 auto;
    overflow-x: auto;

  }
  .details-img{
    width: 360px;height: 360px;margin: 30px;
  }
	.details-info-css{
    margin: 30px 30px 0 0;
		font-size: 30px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #333333;
    line-height: 32px;

	}
	.details-info-title-css{
    margin:20px 0 30px 0;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #666666;
    margin-right: 30px;
  }
  .details-button-go:hover{
    background: #FF7931;
    border-radius: 4px;
  }
    .details-button-go:active,.details-button-go:focus{
    background: #F34500;
    border-radius: 4px;
  }
  .details-info-num{
    margin:40px 0 50px 0;
  }
	.details-button-go{
		width: 140px;
		height: 40px;
		background: #FF620D;
		border-radius: 4px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
    line-height: 20px;
        border: 0px;
  }
  .details-button-join:hover{
    background: rgba(255, 98, 13, 0.05);
    border: 1px solid #FF620D;
    border-radius: 4px;}
	.details-button-join{
		width: 140px;
		height: 40px;
		background: #FFFFFF;
		border: 1px solid #FF620D;
		border-radius: 4px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FF620D;
    line-height: 20px;margin-left: 20px

	}
	.detail-server-div{
    width: 1200px;
    min-width: 1200px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    margin: 20px auto;
    overflow-x: auto;
	}
	.detail-server-font{

		height: 25px;
		font-size: 26px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 20px;float: left;
		margin-left: 30px;
		margin-top: 30px;
    margin-bottom: 30px;
	}
</style>



// WEBPACK FOOTER //
// GoodsDetails.vue?09470623